import * as React from 'react';

import { cn } from '@/lib/utils';

/**
 * Boutons d'icônes pour changer la disposition des données (tableau, cartes,
 * colonnes…). Même rendu sur toutes les pages qui l'offrent.
 *
 * `options`: `[{ value, titre, texteLecteur, icone: Icone, testid? }]`.
 * `titre` s'affiche au survol; `texteLecteur` est lu par les lecteurs d'écran.
 */
const ViewSwitcher = ({
  value,
  onChange,
  options,
  ariaLabel = 'Affichage',
  className,
  testid,
}) => (
  <div
    className={cn('flex rounded-lg border border-border bg-muted p-0.5', className)}
    role="group"
    aria-label={ariaLabel}
    data-testid={testid}
  >
    {options.map(({ value: optionValue, titre, texteLecteur, icone: Icone, testid: optionTestid }) => {
      const actif = value === optionValue;
      return (
        <button
          key={optionValue}
          type="button"
          onClick={() => onChange(optionValue)}
          aria-pressed={actif}
          className={cn(
            'rounded-md p-1.5 transition-colors',
            actif
              ? 'bg-card text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground',
          )}
          title={titre}
          data-testid={optionTestid}
        >
          <Icone className="h-4 w-4" aria-hidden="true" />
          <span className="sr-only">{texteLecteur || titre}</span>
        </button>
      );
    })}
  </div>
);
ViewSwitcher.displayName = 'ViewSwitcher';

export { ViewSwitcher };
